import { signal } from "@angular/core";

export interface MenuItem {
    title: string;
    link: string;
    globalcontentid: string;
    inputdata: any;
    list: MenuItem[];
    isitem: boolean;
    active: boolean;
}

export class Menu {
    currentMenuName: string = '';
    currentMenuName2: string = '';
    menu: MenuItem;
    frommain: any;
    fromoffice: any;
    menuurlaubssuchen: any[] = [];
    menuurlaubsziele: any[] = [];
    menuoffice: any[] = [];
    menuextra: any[] = [];
    allmenus: any[] = [];

    setMenus(menu: any): void {
        this.frommain = menu.frommain;
        this.fromoffice = menu.fromoffice;
        if (this.fromoffice?.menus?.length > 0) {
            this.menuoffice = this.fromoffice.menus;
        }

        if (this.fromoffice?.menus?.length > 0) {
            this.allmenus = [...this.fromoffice.menus, ...this.frommain?.menus];
        } else if (this.frommain?.menus) {
            this.allmenus = [...this.frommain.menus];
        }
        // console.log(this.allmenus)
        if (this.frommain?.menus?.length > 0) {
            for (let i = 0; i < this.frommain.menus.length; i++) {
                if (this.frommain.menus[i].title === 'Urlaubssuche') {
                    if (this.frommain.menus[i].column?.length > 0) {
                        this.menuurlaubssuchen = [this.frommain.menus[i]];
                    }
                } else if (this.frommain.menus[i].title === 'Urlaubsziele') {
                    if (this.frommain.menus[i].column?.length > 0) {
                        this.menuurlaubsziele = [this.frommain.menus[i]];
                    }
                } else {
                    if (this.frommain.menus[i].column?.length > 0) {
                        this.menuextra = [...this.menuextra, this.frommain.menus[i]];
                    }
                }

            }
        }

        // this.setCurrentMenu2(menu);
    }
}
